export default {"src":"/_next/static/media/deco_checkout_applepaylogo.dac0c4d0.svg","height":32,"width":59,"blurWidth":0,"blurHeight":0};